export const MODAL_TYPES = {
  CREDIT_TOPUP: 'credit_topup',
  TRIAL_LIMITATION: 'trial_limitation',
  PURCHASE_SUCCESS: 'purchase_success',
  ENTERPRISE_CREDITS_EXHAUSTED: 'enterprise_credits_exhausted',
} as const;
